import { getCourtTypeObj } from "helper/LocalStorage"
import { isMerchant } from "helper/Admin"
import { getUrlCourtCode } from "helper/Court"
import { getFirstLetters } from "helper/String"
export const operationalHours = (startDate = "06:00", endDate = "23:00") => {
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ];

  return days.map(day => ({
    day,
    isActive: true,
    operationalHours: {
      start: startDate,
      end: endDate
    },
    hours: []
  }));
};
export const dayOptions = [
    {
        label: "Monday",
        value: "Mon",
        number: 1,
    },
    {
        label: "Tuesday",
        value: "Tue",
        number: 2,
    },
    {
        label: "Wednesday",
        value: "Wed",
        number: 3,
    },
    {
        label: "Thursday",
        value: "Thu",
        number: 4,
    },
    {
        label: "Friday",
        value: "Fri",
        number: 5,
    },
    {
        label: "Saturday",
        value: "Sat",
        number: 6,
    },
    {
        label: "Sunday",
        value: "Sun",
        number: 0,
    },
]
export const timeOptions = [
    {
        label: "00:00",
        value: "00:00"
    },
    {
        label: "01:00",
        value: "01:00"
    },
    {
        label: "02:00",
        value: "02:00"
    },
    {
        label: "03:00",
        value: "03:00"
    },
    {
        label: "04:00",
        value: "04:00"
    },
    {
        label: "05:00",
        value: "05:00"
    },
    {
        label: "06:00",
        value: "06:00"
    },
    {
        label: "07:00",
        value: "07:00"
    },
    {
        label: "08:00",
        value: "08:00"
    },
    {
        label: "09:00",
        value: "09:00"
    },
    {
        label: "10:00",
        value: "10:00"
    },
    {
        label: "11:00",
        value: "11:00"
    },
    {
        label: "12:00",
        value: "12:00"
    },
    {
        label: "13:00",
        value: "13:00"
    },
    {
        label: "14:00",
        value: "14:00"
    },
    {
        label: "15:00",
        value: "15:00"
    },
    {
        label: "16:00",
        value: "16:00"
    },
    {
        label: "17:00",
        value: "17:00"
    },
    {
        label: "18:00",
        value: "18:00"
    },
    {
        label: "19:00",
        value: "19:00"
    },
    {
        label: "20:00",
        value: "20:00"
    },
    {
        label: "21:00",
        value: "21:00"
    },
    {
        label: "22:00",
        value: "22:00"
    },
    {
        label: "23:00",
        value: "23:00"
    }
]

const defaultCourtType = {
    all_court: "All Court",
    indoor: "Indoor",
    outdoor: "Outdoor",
    hitting_room: "Hitting",
    paddle_indoor: "Paddle",
    pickle_indoor: "Pickleball",
}

export const baseCourtTypeObj = {
    ...defaultCourtType,
    ...(getCourtTypeObj ? JSON.parse(getCourtTypeObj) : {})
}

export const courtTypeObj = new Proxy(baseCourtTypeObj, {
    get(target, prop) {
        if (typeof prop !== "string") return target[prop]

        if (prop in target) {
            return target[prop]
        }

        return prop
            .split("_")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
    }
})

export const courtTypeOption = [
    {
        label: "Indoor",
        value: "indoor"
    },
    {
        label: "Outdoor",
        value: "outdoor"
    },
    {
        label: "Hitting Room",
        value: "hitting_room"
    },
]
export const courtTypePackageOption = [
    {
        label: "All Court",
        value: "all_court"
    },
    {
        label: "Outdoor",
        value: "outdoor"
    },
    {
        label: "Hitting Room",
        value: "hitting_room"
    },
]
export const availableMonthOption = [
    // {
    //     label: "Month + 0",
    //     value: 0
    // },
    {
        label: "Month + 1",
        value: 1
    },
    {
        label: "Month + 2",
        value: 2
    },
    {
        label: "Month + 3",
        value: 3
    },
    // {
    //     label: "Month + 4",
    //     value: 4
    // },
    // {
    //     label: "Month + 5",
    //     value: 5
    // },
    // {
    //     label: "Month + 6",
    //     value: 6
    // },
]
export const validityMonthOption = [
    {
        label: "3 Month",
        value: 3
    },
    {
        label: "4 Month",
        value: 4
    },
    {
        label: "5 Month",
        value: 5
    },
    {
        label: "6 Month",
        value: 6
    },
    {
        label: "7 Month",
        value: 7
    },
    {
        label: "8 Month",
        value: 8
    },
    {
        label: "9 Month",
        value: 9
    },
    {
        label: "10 Month",
        value: 10
    },
    {
        label: "11 Month",
        value: 11
    },
    {
        label: "12 Month",
        value: 12
    },
]
export const paymentType = [
    {
        label: "Virtual Account (VA)",
        value: "VA"
    },
    {
        label: "Bank Transfer",
        value: "TF"
    },
]
export function providerOption() {
    let list = [
        {
            label: "QRIS",
            value: "qris"
        },
    ]
    let add = []
    if (isMerchant()) {
        add = [
            {
                label: `${getUrlCourtCode().toUpperCase()}R QR`,
                value: 'manual'
            },
            {
                label: "Value Pack",
                value: "value-pack"
            }
        ]
    } else {
        add = [
            {
                label: "Virtual Account (VA)",
                value: "va"
            },
            {
                label: `${getUrlCourtCode().toUpperCase()}-HO`,
                value: `${getUrlCourtCode()}-ho`
            }
        ]
    }
    return [...add, ...list];
}
export const providerType = (e) => {
    switch (e) {
        case "bank_transfer":
        case "Bank Transfer":
        case "Admin": return isMerchant() ? `${getUrlCourtCode().toUpperCase()}R QR` : `${getUrlCourtCode().toUpperCase()}-HO`
        case "qris": return "QRIS"
        case "value_pack": return "Value Pack"
        case "manual": return "Manual"
        case "Value Pack": return "Value Pack"
        default: return "-"
    }
}
export const discountType = [
    {
        label: "Percentage (%)",
        value: "percentage"
    },
    {
        label: "Nominal",
        value: "nominal"
    },
]
export const AddonTypeOption = [
    {
        label: 'Service',
        value: 'service'
    },
    {
        label: 'Rent',
        value: 'rent'
    },
    {
        label: 'Buy',
        value: 'sell'
    },
]
export const roleOption = [
    { value: 'superadmin', label: "Super Admin" },
    { value: 'admin', label: "Admin" },
    { value: 'marketing', label: "Marketing" },
    { value: 'management', label: "Management" },
    { value: 'bod', label: "Board of Directors" },
    { value: 'support', label: "Support" },
]
export const orderType = (e) => {
    if (e === "value_pack") {
        return "Value Pack"
    } if (e === "booking") {
        return "Court Booking"
    } if (e === "rent") {
        return "Rent"
    } if (e === "sell") {
        return "Buy"
    } if (e === "service") {
        return "Service"
    } if (e === "class") {
        return "Class"
    } if (e === "add_on") {
        return "Add On"
    } else { return "-" }
}
export const orderTypeOption = [
    { value: 'value_pack', label: "Value Pack" },
    { value: 'booking', label: "Court Booking" },
    { value: 'add_on', label: "Add On" },
    { value: 'service', label: "Service" },
    { value: 'class', label: "Class" },
    { value: 'rent', label: "Rent" },
    { value: 'sell', label: "Buy" },
]
export const orderStatusOption = [
    { value: "", label: "All" },
    { value: "waiting_payment", label: "Waiting Payment" },
    { value: "payment_failed", label: "Payment Failed" },
    { value: "paid", label: "Paid" },
    { value: "rent", label: "Rent" },
    // { value: "counter_pickup", label: "Counter Pickup" },
    { value: "completed", label: "Completed" },
]
export const userStatus = [
    { value: 'regular', label: "Regular" },
    { value: 'superuser', label: "Super User" },
    { value: 'coach', label: "Coach" },
    { value: 'rally_partner', label: "Rally Partner" },
    { value: 'ball_boy', label: "Ballboy" },
    { value: 'subscriber', label: "Subscriber" },
    { value: 'verified', label: "Verified" },
    { value: 'counter', label: "Counter" }
]
export const serviceRole = (counter, staff) => {
    if (counter && staff) {
        return "Counter, Staff"
    } else if (counter) {
        return "Counter"
    } else if (staff) {
        return "Staff"
    } else {
        return "-"
    }
}
export const optionStatus = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
]
export const trueFalseOptions = [
    { label: "All", value: '' },
    { label: "Active", value: 'true' },
    { label: "Not Active", value: 'false' }
]
export const advancedSchedule = [
    { value: 1, label: "Month + 1" },
    { value: 2, label: "Month + 2" },
    { value: 3, label: "Month + 3" },
    { value: 6, label: "6 Month" },
    { value: 12, label: "12 Month" },
    { value: 9999, label: "All" },
]
export const userStatusOptions = [
    { value: 'rally_partner', label: "Rally Partner" },
    { value: 'ball_boy', label: "Ballboy" }
]
export const userStatusObj = {
    'rally_partner': "Rally Partner",
    'ball_boy': "Ballboy"
}
export const DBCR = [
    { value: 'DB', label: "DB" },
    { value: 'CR', label: "CR" }
]
export const genderOptions = [
    { value: 'male', label: "Male" },
    { value: 'female', label: "Female" }
]
export const availableOption = [
    { value: "true", label: "Available" },
    { value: "false", label: "Not Available" }
]
export const activeOption = [
    { value: 'all', label: "All" },
    { value: 'true', label: "Active" },
    { value: 'false', label: "Inactive" }
]
export const coachingTypeOption = [
    { value: 'coaching', label: 'Coaching' },
    { value: 'sparring', label: 'Sparring' }
]
export const verifiedOption = [
    { value: 'verified', label: 'Verified' },
    { value: 'pending', label: 'Verification Pending' }
]
export const color = {
    purple: "#663399",
    orange: "#F79256",
    darkorange: "#623A22",
    darkgreen: "#3E675B",
    blue: "#1D4E89",
    grey: "#9DA6AB",
    red: "#FF2115",
    blueIndoor_1: "#025597",
    blueIndoor_2: "#0198E1",
    primary: "#025597",
    green: "#4DBD74",
    pink: "#E35480",
    lightblue: "#e1edffff"
}
export const periodOptions = [
    {
        label: "Order Time",
        value: "order_time"
    },
    {
        label: "Session Date",
        value: "session_date"
    },
    // {
    //     label: "Complete Date",
    //     value: "complete_date"
    // }
]
export const listMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];
export const chartColor = {
    backgroundColor: '#2196F3',
    borderColor: '#2196F3',
    borderWidth: 1
}

export const orderTypeOptions = [
    {
        label: "Value Pack",
        value: "value_pack"
    },
    {
        label: "Booking",
        value: "booking"
    },
    {
        label: "Service",
        value: "service"
    },
    {
        label: "Class",
        value: "class"
    },
    {
        label: "Rent",
        value: "rent"
    },
    {
        label: "Buy",
        value: "buy"
    },
    {
        label: "Sell",
        value: "buy"
    },
]

export const orderTypeCategoryOptions = [
    {
        label: "All",
        value: "all"
    },
    {
        label: "Court Booking",
        value: "booking"
    },
    {
        label: "AddOn",
        value: "add_on"
    },
    {
        label: "Value Pack",
        value: "value_pack"
    },
]

export const typeOptions = [
    { value: "ORDER", label: "Order" },
    { value: "COURT", label: "Court" },
    { value: "PACKAGE", label: "Package" }
]

function getPlaces() {
    const raw = localStorage.getItem('court_place');
    const courts = raw ? JSON.parse(raw) : null;
    // const codeCount = {};
    // const court = courts?.map((value) => {
    //     const baseCode = getFirstLetters(value.name);

    //     codeCount[baseCode] = (codeCount[baseCode] || 0) + 1;

    //     const uniqueCode = codeCount[baseCode] === 1 ? baseCode : `${baseCode}${codeCount[baseCode]}`;
    //     return {
    //         id: value._id || value.id,
    //         name: value.name,
    //         code: uniqueCode,
    //         merchantId: value.merchantId || '',
    //         allowedMenu: value.menu
    //     }
    // })
    // console.log('here court', court)
    return courts
}

export const courtOptions = getPlaces() || []

//Hard code
export const menuOptions = [
    { value: "653f5d9006520fccd4ab4604", label: "STC" },
    { value: "69b3a2e8c994e1353f8b2074", label: "TERRA" },
    { value: "69998512645119381424b48e", label: "TBR" }
]